import { _ } from '@splunk/ui-utils/i18n';
import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that it can set tokens based on item events
 * @param {LayoutItem} Item The item to enhance
 */
export const withResetTokens: PresetHOC<{
    canResetTokens?: boolean;
    interactionsFilterMetadata?: string[];
}> = (Item) => {
    Item.canResetTokens = true;
    Item.interactionsFilterMetadata ??= [];
    Item.interactionsFilterMetadata.push(_('Reset tokens'));

    return Item;
};
